import React from 'react';
import Title from '../../title';
import { Grid, Button, Dropdown } from 'semantic-ui-react';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loading';
import ReadCookie from '../../../functions/readcookies';
import Transfer from './transfer';

class Accounting extends React.Component {

  state = {
    data: [],
    selectedType: ''
  }

  componentDidMount() {
    this.checkBranch();
  }

  checkBranch() {
    let data = (ReadCookie("branch"));
    let branchId;
    for (var i = 0; i < data.length; i++) {
      branchId = data[i].branch_id;
    }
    this.setState({ branchId })
    this.getPurchaserAndCustomerAndLedger(branchId);
  }

  getPurchaserAndCustomerAndLedger(branchId) {
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    this.setState({ load: true, message: 'Getting Purchaser Details!!!!' });
    $.ajax({
      type: 'POST', data: { 'executiveId': userId, branchId },
      url: Server() + 'accounting/getpurchaserandcustomerandledger.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          context.setState({ data })
        } catch (e) { alert('Error To Get Purchaser!!!') }
      },
      error: function(err) {
        context.setState({ load: false, });
        alert('Try again!!!!')
      }
    });
  }


  onChangeType = (type) => (f, { value }) => { this.setState({ [type]: value, dropdown: '', value: '' }) }


  getTypeValue() {
    return this.state.selectedType;
  }

  getValue() {
    if (this.state.value == 0 || this.state.value == '0') {
      return this.state.dropdown;
    }
    return this.state.value;
  }

  onSelect = event => {
    let val = event.target.value;
    let value = val.split('->')[0];
    this.setState({ dropdown: event.target.value, value })
  }

  render() {
    let typeOption = [
      { key: 'Customer', text: 'Customer', value: 'Customer' },
      { key: 'Machine Customer', text: 'Machine Customer', value: 'Machine Customer' },
      { key: 'Purchaser', text: 'Purchaser', value: 'Purchaser' },
      { key: 'Ledger', text: 'Ledger', value: 'Ledger' },
      { key: 'Expense', text: 'Expense', value: 'Expense' },
    ];
    let filter = (<div></div>);
    if (this.state.selectedType == 'Customer') {
      filter = (
        <Grid.Column mobile={16} tablet={16} computer={7}>
          <b>Customer</b><br/>
            <datalist id="suggestionCustomer">
                {this.state.data.map((y) => {
                  if (y.type == 'Customer') {
                    return (
                      <option id='box'>{y.id+'->'+y.name}</option>
                    )
                  }
                })}
            </datalist>
            <input style={{height: 35, width: '100%'}} onChange={this.onSelect} autoComplete="on"
            list="suggestionCustomer" value={this.state.dropdown} />
        </Grid.Column>
      );
    }


    if (this.state.selectedType == 'Machine Customer') {
      filter = (
        <Grid.Column mobile={16} tablet={16} computer={7}>
          <b>Customer</b><br/>
            <datalist id="suggestionCustomer1">
                {this.state.data.map((y) => {
                  if (y.type == 'Machine Customer') {
                    return (
                      <option id='box'>{y.id+'->'+y.name}</option>
                    )
                  }
                })}
            </datalist>
            <input style={{height: 35, width: '100%'}} onChange={this.onSelect} autoComplete="on"
            list="suggestionCustomer1" value={this.state.dropdown} />
        </Grid.Column>
      );
    }


    if (this.state.selectedType == 'Purchaser') {
      filter = (
        <Grid.Column mobile={16} tablet={16} computer={7}>
          <b>Purchaser</b><br/>
            <datalist id="suggestionPurchaser">
                {this.state.data.map((y) => {
                  if (y.type == 'Purchaser') {
                    return (
                      <option id='box'>{y.id+'->'+y.name}</option>
                    )
                  }
                })}
            </datalist>
            <input style={{height: 35, width: '100%'}} onChange={this.onSelect} autoComplete="on"
            list="suggestionPurchaser" value={this.state.dropdown} />
        </Grid.Column>
      );
    }
    if (this.state.selectedType == 'Ledger') {
      filter = (
        <Grid.Column mobile={16} tablet={16} computer={7}>
          <b>Ledger</b><br/>
            <datalist id="suggestionLedger">
                {this.state.data.map((y) => {
                  if (y.type == 'Ledger') {
                    return (
                      <option id='box'>{y.id+'->'+y.name}</option>
                    )
                  }
                })}
            </datalist>
            <input style={{height: 35, width: '100%'}} onChange={this.onSelect} autoComplete="on"
            list="suggestionLedger" value={this.state.dropdown} />
        </Grid.Column>
      );
    }

    if (this.state.selectedType == 'Expense') {
      filter = (
        <Grid.Column mobile={16} tablet={16} computer={7}>
          <b>Expenses</b><br/>
            <datalist id="suggestionExpense">
                {this.state.data.map((y) => {
                  if (y.type == 'Expense') {
                    return (
                      <option id='box'>{y.id+'->'+y.name}</option>
                    )
                  }
                })}
            </datalist>
            <input style={{height: 35, width: '100%'}} onChange={this.onSelect} autoComplete="on"
            list="suggestionExpense" value={this.state.dropdown} />
        </Grid.Column>
      );
    }

    return (
      <div>
        <Grid>
          <Grid.Column mobile={16} tablet={16} computer={10}>
            <div style={{display: 'flex'}}>
              <div>
                <b>Type</b><br/>
                <Dropdown fluid onChange={this.onChangeType('selectedType')}
                  selection options={typeOption} style={{marginBottom: '2%', width: '200px'}} 
                  value={this.state.selectedType}  />
              </div>
              <div>
                {filter}
              </div>
            </div>
          </Grid.Column>
          
          <Grid.Column mobile={16} tablet={16} computer={4}><br/>
            <div style={{display: 'flex'}}>
              <Button onClick={ () => { this.props.getAccountDetails() }}>SUBMIT</Button>
              { this.props.menuPermission.add ?
                (<Transfer type="all" transferControl={this.props.transferControl}  />):''
              }
            </div>
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

export default Accounting;
